/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ offers: NonNullable<unknown>, brokers: NonNullable<unknown> }} Ebr_Confirm_SummaryInputs */

const cs_ebr_confirm_summary = /** @type {(inputs: Ebr_Confirm_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zapíše se: ${i?.offers} nabídek, ${i?.brokers} makléřů.`)
};

const en_ebr_confirm_summary = /** @type {(inputs: Ebr_Confirm_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Will write: ${i?.offers} offers, ${i?.brokers} brokers.`)
};

/**
* | output |
* | --- |
* | "Will write: {offers} offers, {brokers} brokers." |
*
* @param {Ebr_Confirm_SummaryInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_confirm_summary = /** @type {((inputs: Ebr_Confirm_SummaryInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Confirm_SummaryInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_confirm_summary(inputs)
	return cs_ebr_confirm_summary(inputs)
});